/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: timeConditionsActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Incoming Call Tools module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteTimeCondition } from './api/timeConditionApi';

/**
 * Shared helpers for Time Conditions module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Time Condition in the form.
 * Pattern: /pbx/incoming-tools/time-conditions/new?duplicate={id}
 */
export const getTimeConditionDuplicateUrl = (id: string | number): string =>
  `/pbx/incoming-tools/time-conditions/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Time Condition id.
 */
export const navigateToTimeConditionDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getTimeConditionDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Time Condition by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteTimeConditionById = async (id: string | number): Promise<void> => {
  await deleteTimeCondition(id);
};



